<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="isotr112281" :items="this.listIsotr112281" label="Historial" item-text="fecha"
                              return-object required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.isotr112281!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.isotr112281.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Manipulación manual de cargas ISO/TR 11228-1</div>
                    </template>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>Manipulación manual de cargas ISO/TR 11228-1</h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Preguntas clave
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Identificación del peligro
                                        <br/>"Pregunta Clave"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>IDENTIFICACIÓN DEL PELIGRO ERGONÓMICO POR LEVANTAMIENTO DE CARGAS</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>Marque con una “X” la respuesta a cada una de las siguientes condiciones</b>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" bgcolor="#CCCCAA">
                                <b>En el puesto de trabajo hay alguna tarea que presente alguna de las siguientes
                                    condiciones:</b>
                            </td>
                            <td align="center" bgcolor="#CCCCAA">Respuesta</td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >1. ¿Se deben levantar, sostener y depositar objetos manualmente en este puesto de trabajo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112281.switch1"
                                          :label="`${this.isotr112281.switch1 ? 'Si' : 'No'}`"
                                          @change="ableDisableSwitch"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td bgcolor="#FFFFFF">2. ¿Alguno de los objetos a levantar manualmente pesa 3 kg o más?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch2"
                                          :label="`${this.isotr112281.switch2 ? 'Si' : 'No'}`"
                                          @change="ableDisableSwitch"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >3. ¿La tarea de levantamiento se realiza de forma habitual dentro del turno de trabajo (por
                                lo menos una vez en el turno)?
                            </td>
                            <td>
                                <v-switch v-model="isotr112281.switch3"
                                          :label="`${this.isotr112281.switch3 ? 'Si' : 'No'}`"
                                          @change="ableDisableSwitch"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CF6D6D">
                                <b>Si todas las respuestas son “SI” para todas las condiciones, hay presencia del
                                    peligro por levantamiento manual de cargas y debe realizarse una evaluación
                                    específica del riesgo.</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#ABCF6D">
                                <b>Si alguna de las respuestas a las condiciones es “NO”, no hay presencia del peligro
                                    por levantamiento de cargas.</b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>

                    <table style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Identificación del peligro
                                        <br/>"Pregunta Clave"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>IDENTIFICACIÓN DEL PELIGRO ERGONÓMICO POR TRANSPORTE DE CARGAS</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>Marque con una “X” la respuesta a cada una de las siguientes condiciones</b>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" bgcolor="#CCCCAA">
                                <b>En el puesto de trabajo hay alguna tarea que presente alguna de las siguientes
                                    condiciones:</b>
                            </td>
                            <td align="center" bgcolor="#CCCCAA">Respuesta</td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >¿En el puesto de trabajo hay una tarea que requiere el levantamiento o el descenso manual
                                de una carga igual o superior a 3kg que debe ser transportada manualmente a una
                                distancia mayor de 1 metro?
                            </td>
                            <td>
                                <v-switch v-model="isotr112281.switch4"
                                          :label="`${this.isotr112281.switch4 ? 'Si' : 'No'}`"
                                          @change="ableDisableSwitch"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CF6D6D">
                                <b>Si la respuesta a la condición es “SI”, hay presencia del peligro por transporte de
                                    cargas y debe realizarse una evaluación específica del riesgo.</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#ABCF6D">
                                <b>Si la respuesta a la condición es “NO”, no hay presencia del peligro por transporte
                                    de cargas.</b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Evaluación Rápida
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <!--Evaluacion rapida-->
                    <table border="1" style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                <b>
                                    <center>Evaluación rápida para identificar la presencia de condiciones aceptables
                                        (Zona verde)
                                    </center>
                                    <br/>NOTA: Señale con una “X”, cuando la condición verificada está en presente
                                    (columna "SI") y cuando no está presente (columna "NO")
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>
                                ¿El peso de la carga no supera los 25 Kg (20 kg para mujeres) y los levantamientos se
                                realizan únicamente de forma ocacional (no más de 3 levantamientos en el turno)?
                                <br/>
                                <br/>O bien,
                                <br/>
                                <br/>¿El peso de la carga no supera los 14 kg (11 kg para mujeres) y la frecuencia de
                                levantamientos no excede de 1 levatamiento/minuto?
                                <br/>
                                <br/>O bien,
                                <br/>
                                <br/>¿El peso de la carga no supera los 6 kg (5 kg para mujeres) y la frecuencia de
                                levantamientos no excede de 5 levantamiento/minuto?
                            </td>
                            <td>
                                <v-switch v-model="isotr112281.switch5" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿El desplazamiento vertical se realiza entre la cadera y los hombros?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch6" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿EL tronco está erguido y no flexionado ni en torsión?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch7" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch7 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿La carga se mantiene muy cerca del cuerpo (no más de 10 cm. de la parte frontal del
                                torso)?
                            </td>
                            <td>
                                <v-switch v-model="isotr112281.switch8" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch8 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si a
                                <b>todas</b> las preguntas ha contestado
                                <b>"SI"</b> entonces la tarea tiene un riesgo aceptable y está en la
                                <b>ZONA VERDE</b>.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si
                                <b>una</b> o más respuestas son
                                <b>"NO"</b>, compruebe si se trata de una tarea con un nivel de riesgo inaceptable según
                                la siguiente tabla.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table border="1" style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                <center>
                                    <b>Evaluación rápida para identificar la presencia de riesgo inaceptable (Zona
                                        roja)</b>
                                </center>
                                <b>
                                    <br/>NOTA: Señale con una “X”, cuando la condición verificada está en presente
                                    (columna "SI") y cuando no está presente (columna "NO")
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿La distancia vertical es superior a 175 cm o está por debajo del nivel del suelo?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch9" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch9 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿El desplazamiento vertical es superior a 175 cm?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch10" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch10 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿La distancia horizontal es superior a 63 cm fuera del alcance máximo?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch11" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch11 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿El angulo de asimetría es superior a 135°?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch12" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch12 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Se realizan más de 15 levantamientos/min en una Duración Corta?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch13" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch13 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Se realizan más de 12 levantamientos/min en una Duración Moderada?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch14" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch14 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Se realizan más de 8 levantamientos/min en una Duración Larga?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch15" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch15 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿La tarea la pueden realizar mujeres y la carga pesa más de 20 kg.?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch16" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch16 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿La tarea la realizan únicamente hombres y la carga pesa más de 25 kg.?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch17" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch17 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Se manipula una masa acumulada de más de 10.000 kg a lo largo del turno?</td>
                            <td>
                                <v-switch v-model="isotr112281.switch18" :disabled="this.disableSwitch"
                                          :label="`${this.isotr112281.switch18 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                Si
                                <b>alguna</b> de las respuestas es
                                <b>"SI"</b> la tarea probablemente está en la
                                <b>ZONA ROJA</b> y tiene un nivel de riesgo inaceptable. Se recomienda realizar la
                                evaluación especifica del riesgo de la tarea por manipulación manual de cargas para
                                definir intervención.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                Si
                                <b>todas</b> las respuestas son
                                <b>"NO"</b>, no es posible discriminar el nivel de riesgo de forma rápida y por tanto,
                                es necesario realizar la evaluación específica.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="isotr112281!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Isotr112281 from "../../../model/Isotr11228-1"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                isotr112281: null,
                listIsotr112281: [],
                valid: true,
                search: '',
                disableSwitch: true,
                dialogError: false,
                dialogSuccess: false,
            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                console.log(this.isotr112281)
                this.isotr112281 = new Isotr112281();
                console.log(this.isotr112281)
                this.isotr112281.fecha = e
                this.listIsotr112281.push(this.isotr112281)
            },


            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.isotr112281.id != '' && this.isotr112281.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.isotr112281.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.isotr112281)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.isotr112281)
                        monitoringNew.form = 51
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.isotr112281.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            ableDisableSwitch() {
                if (this.isotr112281.switch1
                    && this.isotr112281.switch2
                    && this.isotr112281.switch3
                    && this.isotr112281.switch4) {
                    this.disableSwitch = false;
                }
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 51
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.isotr112281 = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listIsotr112281 = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listIsotr112281.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {},
        created() {
            this.reloadData()
        },
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Isotr11228-1.vue